import { useQuery } from '@tanstack/react-query';

import { useMarket } from '@/providers/MarketProvider';
import { fetchAvailableMembershipPlansClient } from '@/services/graphql/available-membership-plans';

interface UseAvailableMembershipPlansOptions {
  enabled?: boolean;
}

export const getAvailableMembershipPlansQueryKey = (market: string) =>
  ['loyaltyAvailableMembershipPlans', market] as const;

export const useAvailableMembershipPlans = (options: UseAvailableMembershipPlansOptions = {}) => {
  const { market } = useMarket();
  const { enabled = true } = options;

  return useQuery({
    queryKey: getAvailableMembershipPlansQueryKey(market),
    queryFn: fetchAvailableMembershipPlansClient,
    enabled: enabled && !!market,
    retry: false,
  });
};
